import React from 'react';
import { Grid } from 'fw/forms';
import API from 'fw/system/API';
import * as APIModules from 'modules/app/API';
import SearchQueueLinkByTypeAndRange from 'areas/shared/components/formatter/SearchQueueLinkByTypeAndRange';

const columns = [
	{ key: 'typeName', name: 'APPs by Types', width: 300, sortable: false },
	{ key: 'range0To30DaysSinceStartCount', name: '<30 Days', formatter: SearchQueueLinkByTypeAndRange, getRowMetaData: (row) => [row, 1], sortable: false },
	{ key: 'range30To60DaysSinceStartCount', name: '30-60 Days', formatter: SearchQueueLinkByTypeAndRange, getRowMetaData: (row) => [row, 2], sortable: false },
	{ key: 'range60PlusDaysSinceStartCount', name: '+60 Days', formatter: SearchQueueLinkByTypeAndRange, getRowMetaData: (row) => [row, 3], sortable: false },
	{ key: 'totalCount', name: 'Total', formatter: SearchQueueLinkByTypeAndRange, getRowMetaData: (row) => [row, null], sortable: false }
];

class OpenApplicationTypes extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = (props) => {
		return {
			list: []
		};
	}

	componentDidMount() {
		this.handleSearch();
	}

	handleSearch = (filters, callback) => {
		this.setState({
			list: []
		}, function () {
			this.search(null, callback);
		});
	}

	search = (opts, callback) => {
		const rq = Object.assign({}
		);

		var state = {
			list: []
		};

		new API().post(APIModules.Admin.url('/dashboard/getOpenApplicationsByType'), rq,
			{
				success: (r) => {
					const items = r.data.items || [];

					// Calculate totals row
					const totalsRow = {
						typeCode: 'TOTALS',
						typeName: 'TOTALS',
						range0To30DaysSinceStartCount: items.reduce((sum, item) => sum + item.range0To30DaysSinceStartCount, 0),
						range30To60DaysSinceStartCount: items.reduce((sum, item) => sum + item.range30To60DaysSinceStartCount, 0),
						range60PlusDaysSinceStartCount: items.reduce((sum, item) => sum + item.range60PlusDaysSinceStartCount, 0),
						totalCount: items.reduce((sum, item) => sum + item.totalCount, 0)
					};

					state = {
						list: [...items, totalsRow]
					};

					// Store search results
					this.setState(state);

					// Callback
					if (callback)
						callback();
				}
			});

		return state;
	}

	render() {
		return (
			<React.Fragment>
				<div className="apps-by-type-grid">
					<Grid
						columns={columns}
						items={this.state.list}
						height={212}
						rowKey="typeCode"
						name="default" />
				</div>
				<table className="dashboard-print-table apps-by-type-print">
					<thead>
						<tr>
							<th>APPs by Types</th>
							<th>&lt;30 Days</th>
							<th>30-60 Days</th>
							<th>+60 Days</th>
							<th>Total</th>
						</tr>
					</thead>
					<tbody>
						{this.state.list.map((row, i) => (
							<tr key={i} className={row.typeCode === 'TOTALS' ? 'print-totals-row' : ''}>
								<td>{row.typeName}</td>
								<td>{row.range0To30DaysSinceStartCount}</td>
								<td>{row.range30To60DaysSinceStartCount}</td>
								<td>{row.range60PlusDaysSinceStartCount}</td>
								<td>{row.totalCount}</td>
							</tr>
						))}
					</tbody>
				</table>
			</React.Fragment>
		)
	}
}

export default OpenApplicationTypes;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminDashboard/openApplicationTypes/OpenApplicationTypes.js